/* @flow */
import {
  FETCH_MALWARE,
  SAVE_MALWARE,
  DELETE_MALWARE,
  UPDATE_PAGE_FILTERS,
  RESET_PAGE_FILTERS,
} from './action-types.js';

import * as Types from './types';

/* Fetches all Malware terms */
export const fetchAllMalware = (): Object => ({ type: FETCH_MALWARE });

/* Handles save new term and edit term */
export const saveMalware = (malware: Types.MalwareRecordType): Object => ({
  type: SAVE_MALWARE,
  payload: malware,
});

/* Delete by guid */
export const deleteMalware = (malware: Types.MalwareRecordType): Object => ({
  type: DELETE_MALWARE,
  payload: malware,
});

export const updateFilters = (payload: Object, field?: string) => ({
  type: UPDATE_PAGE_FILTERS,
  payload,
  field,
});

export const resetFilters = () => ({ type: RESET_PAGE_FILTERS });



// WEBPACK FOOTER //
// ./src/app/modules/malware/actions.js